"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var AccountSettingsForm_module_css_1 = __importDefault(require("../AccountSettingsForm.module.css"));
var material_1 = require("@mui/material");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var IdpGroupMatchModal_1 = __importDefault(require("./IdpGroupMatchModal"));
var ApiManager_1 = __importDefault(require("@/functions/ApiManager"));
var onlineResourceManager = new q_play_core_1.OnlineResourceManager();
var AdvancedSSO = function () {
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _a = (0, react_1.useState)([]), qteams = _a[0], setQteams = _a[1];
    var _b = (0, react_1.useState)([]), groupMap = _b[0], setGroupMap = _b[1];
    var groupMatchModalState = (0, q_play_components_1.useModal)();
    var deleteConfirmationModalState = (0, q_play_components_1.useModal)();
    var _c = (0, react_1.useState)(), selectedGroupMatch = _c[0], setSelectedGroupMatch = _c[1];
    var _d = (0, react_1.useState)(false), useFallbackTeam = _d[0], setUseFallbackTeam = _d[1];
    var _e = (0, react_1.useState)(-1), fallbackTeam = _e[0], setFallbackTeam = _e[1];
    var getIDPGroupMap = function () {
        var request = onlineResourceManager.makeJSONRequest("/api/idp/group-map");
        request.getDataAsJSON().then(function (IdpGroupMap) {
            setGroupMap(IdpGroupMap);
            var fallbackGroupMap = IdpGroupMap.find(function (groupMatch) { return groupMatch.group_id === "*"; });
            if (fallbackGroupMap) {
                setUseFallbackTeam(true);
                setFallbackTeam(fallbackGroupMap.qteam_id);
            }
        });
    };
    (0, react_1.useEffect)(function () {
        getIDPGroupMap();
        ApiManager_1.default.getQteams().then(function (qteams) {
            setQteams(qteams);
        });
    }, []);
    var deleteRow = function () {
        var request = onlineResourceManager.makeJSONRequest("/api/idp/group-map/" + selectedGroupMatch.id, "DELETE");
        request.getResponseData().then(function () {
            getIDPGroupMap();
        });
        setSelectedGroupMatch(undefined);
        deleteConfirmationModalState.toggle();
    };
    var handleDeleteRowClick = function (groupMatch) {
        setSelectedGroupMatch(groupMatch);
        deleteConfirmationModalState.toggle();
    };
    var handleRowClick = function (groupMatch) {
        setSelectedGroupMatch(groupMatch);
        groupMatchModalState.toggle();
    };
    var createNewGroupMap = function () {
        setSelectedGroupMatch(undefined);
        groupMatchModalState.toggle();
    };
    var changeUseFallbackTeam = function (event) {
        setUseFallbackTeam(event.target.checked);
        if (!event.target.checked)
            setFallbackTeam(-1);
        if (fallbackTeam === -1) {
            setFallbackTeam(qteams[0].id);
        }
        var fallbackGroupMap = groupMap.find(function (groupMatch) { return groupMatch.group_id === "*"; });
        if (fallbackGroupMap && !event.target.checked) {
            var request = onlineResourceManager.makeJSONRequest("/api/idp/group-map/" + fallbackGroupMap.id, "DELETE");
            request.getResponseData().then(function () {
                getIDPGroupMap();
            });
        }
    };
    (0, react_1.useEffect)(function () {
        if (fallbackTeam == -1)
            return;
        var payload = {
            qteam_id: fallbackTeam,
            group_id: "*",
        };
        var fallbackGroupMap = groupMap.find(function (groupMatch) { return groupMatch.group_id === "*"; });
        if (fallbackGroupMap) {
            var request = onlineResourceManager.makeJSONRequest("/api/idp/group-map/" + fallbackGroupMap.id, "PUT", JSON.stringify(payload));
            request.getResponseData().then(function () {
                getIDPGroupMap();
            });
        }
        else {
            var request = onlineResourceManager.makeJSONRequest("/api/idp/group-map/", "POST", JSON.stringify(payload));
            request.getResponseData().then(function () {
                getIDPGroupMap();
            });
        }
    }, [fallbackTeam]);
    return (react_1.default.createElement("div", { id: AccountSettingsForm_module_css_1.default.formContainer },
        react_1.default.createElement("div", { className: AccountSettingsForm_module_css_1.default.title, style: { display: "flex", justifyContent: "space-between" } },
            react_1.default.createElement("span", null, t("Single Sign-On (SSO)")),
            react_1.default.createElement(q_play_components_1.Button, { icon: pro_solid_svg_icons_1.faAdd, onClick: createNewGroupMap, size: "small" })),
        react_1.default.createElement("div", { className: AccountSettingsForm_module_css_1.default.inputContainer },
            react_1.default.createElement("div", { className: "mb-5 w-25" },
                react_1.default.createElement(q_play_components_1.Switch, { label: t("Use fallback team"), onChange: changeUseFallbackTeam, checked: useFallbackTeam }),
                useFallbackTeam && (react_1.default.createElement(q_play_components_1.Select, { onChange: function (event) { setFallbackTeam(parseInt(event.target.value)); }, value: fallbackTeam }, qteams.map(function (qteam) { return (react_1.default.createElement("option", { key: qteam.id, value: qteam.id }, qteam.name)); })))),
            react_1.default.createElement(material_1.TableContainer, { component: material_1.Paper },
                react_1.default.createElement(material_1.Table, null,
                    react_1.default.createElement(material_1.TableHead, null,
                        react_1.default.createElement(material_1.TableRow, null,
                            react_1.default.createElement(material_1.TableCell, { align: "center" }, t("IDP Group ID")),
                            react_1.default.createElement(material_1.TableCell, { align: "center" }, t("Qteam")))),
                    react_1.default.createElement(material_1.TableBody, null, groupMap.map(function (groupMatch) {
                        var _a, _b;
                        if (groupMatch.group_id === "*")
                            return null;
                        return (react_1.default.createElement(material_1.TableRow, { hover: true, role: "checkbox", tabIndex: -1, key: groupMatch.id, sx: { cursor: "pointer" }, onClick: function () { return handleRowClick(groupMatch); } },
                            react_1.default.createElement(material_1.TableCell, { align: "center" }, groupMatch.group_id),
                            react_1.default.createElement(material_1.TableCell, { align: "center" }, (_b = (_a = qteams.find(function (qteam) { return qteam.id === groupMatch.qteam_id; })) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : groupMatch.qteam_id),
                            react_1.default.createElement(material_1.TableCell, { align: "center" },
                                react_1.default.createElement(material_1.IconButton, { onClick: function (event) { event.stopPropagation(); handleDeleteRowClick(groupMatch); } },
                                    react_1.default.createElement("span", null,
                                        react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faTrashCan }))))));
                    }))))),
        react_1.default.createElement(IdpGroupMatchModal_1.default, { isShown: groupMatchModalState.isShown, toggle: groupMatchModalState.toggle, IdpGroupMatch: selectedGroupMatch, qteams: qteams, updateIDPGroupMap: getIDPGroupMap }),
        react_1.default.createElement(q_play_components_1.ConfirmationModal, { isShown: deleteConfirmationModalState.isShown, onClose: deleteConfirmationModalState.toggle, onCancel: deleteConfirmationModalState.toggle, onConfirm: deleteRow, message: t("Confirm delete IDP group match.") })));
};
exports.default = AdvancedSSO;
